import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Button,
  Row,
  Col,
  Card,
  Avatar,
  Input,
  Tag,
  Modal,
  Select,
} from "antd";
import { ExclamationCircleFilled, SendOutlined } from "@ant-design/icons";
import {
  Container,
  Content,
  TicketCard,
  TicketList,
  TicketView,
  ButtonGroup,
  TicketViewHeader,
} from "./styles";
import Status from "../../../components/status";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { useSocket } from "../../../hooks/SocketContext";
import { MdPerson } from "react-icons/md";
import { useAuth } from "../../../hooks/AuthContext";
import { format, isToday } from "date-fns";
import { Message, ViewInput } from "../../../GlobalStyles";
import { useNavigate } from "react-router-dom";

const { confirm } = Modal;

const Atendimentos = () => {
  const { socket } = useSocket();
  const { user } = useAuth();
  const navigate = useNavigate();
  const chatContainerRef = useRef(null);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingChat, setIsLoadingChat] = useState(true);
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [filter, setFilter] = useState("attendant");
  const [newMessage, setNewMessage] = useState("");
  const [sendType, setSendType] = useState("");
  const [sendUser, setSendUser] = useState("");
  const [tickets, setTickets] = useState([]);
  const [countMessages, setCountMessages] = useState(0);
  const [messages, setMessages] = useState([]);
  const [users, setUsers] = useState([]);
  const [collaborators, setCollaborators] = useState([]);
  const [ticketsTotal, setTicketsTotal] = useState(0);
  const [ticketsPedding, setTicketsPedding] = useState([]);
  const [ticketsAttendant, setTicketsAttendant] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isLoadingModal, setIsLoadingModal] = useState(false);

  useEffect(() => {
    if (!selectedTicket) {
      loadChats();
    }
  }, [selectedTicket]);

  useEffect(() => {
    loadingUsersAndTecnicos();
  }, []);

  async function loadingUsersAndTecnicos() {
    await api
      .get(`/users/all?all=true`)
      .then((response) => {
        setUsers(response.data.users);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    await api
      .get(`/collaborators?all=true`)
      .then((response) => {
        setCollaborators(response.data.collaborators);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  useEffect(() => {
    let countMessages = 0;
    ticketsAttendant.map((item) => {
      countMessages += item.messages.filter((data) => {
        return data.send_id != user.id && !data.is_viewed;
      }).length;
    });
    setCountMessages(countMessages);
  }, [ticketsAttendant]);

  useEffect(() => {
    if (!socket.connected) {
      socket.connect();
    }

    socket.on("connect", () => {});

    socket.on("newChat", (ticket) => {
      setTicketsPedding((prevTickets) => [ticket, ...prevTickets]);
    });

    socket.on("acceptChat", (ticket) => {
      setTicketsPedding((prevTickets) =>
        prevTickets.filter((item) => item.id != ticket.id)
      );
    });

    socket.on("newMessage", (message) => {
      playNotificationSound();
      if (selectedTicket && selectedTicket.id == message.ticket_id) {
        setMessages((prevMessagess) => [message, ...prevMessagess]);
      } else {
        setTicketsAttendant((prevTickets) => {
          const targetIndex = prevTickets.findIndex(
            (chat) => chat.id === message.ticket_id
          );

          if (targetIndex === -1) {
            console.warn(`Chat com ID ${message.ticket_id} não encontrado.`);
            return prevTickets;
          }

          const chatToUpdate = prevTickets[targetIndex];

          const remainingChats = prevTickets.filter(
            (chat) => chat.id !== message.ticket_id
          );

          const updatedChat = {
            ...chatToUpdate,
            messages: [message, ...chatToUpdate.messages],
            updated_at: new Date(),
          };
          return [updatedChat, ...remainingChats];
        });
      }
    });

    return () => {
      socket.off("connect");
      socket.off("newChat");
      socket.off("acceptChat");
      socket.off("newMessage");
      socket.off("error");
      socket.disconnect();
    };
  }, [socket, selectedTicket]);

  const notificationSound = useMemo(() => {
    if (typeof Audio !== "undefined") {
      const audio = new Audio("/notification.mp3");
      audio.volume = 0.5;
      return audio;
    }
    return null;
  }, []);

  const playNotificationSound = () => {
    if (notificationSound) {
      // Reinicia a reprodução. Necessário para tocar rapidamente em sequência.
      notificationSound.pause();
      notificationSound.currentTime = 0;

      // Tenta tocar e captura o erro de autoplay
      notificationSound.play().catch((error) => {
        // Notifica no console se o navegador bloqueou o autoplay
        console.warn(
          "Reprodução de áudio bloqueada pelo navegador (Autoplay).",
          error
        );
        // Você pode adicionar um tratamento visual aqui, como um ícone vibrando.
      });
    }
  };

  useEffect(() => {
    if (selectedTicket) {
      loadChat(selectedTicket);
    }
  }, [selectedTicket]);

  async function loadChat(chat) {
    setIsLoadingChat(true);
    await api
      .get(`/ticket/${chat.id}`)
      .then((response) => {
        setMessages(response.data.messages);
      })
      .catch(({ response }) => {
        if (response?.data?.message) {
          toast.warn(response.data.message);
        } else {
          toast.warn(
            "Ocorreu um erro, verifique sua conexão e tente novamente"
          );
        }
      });
    setIsLoadingChat(false);
  }

  async function loadChats() {
    setIsLoading(true);
    await api
      .get(`/attendant/tickets`)
      .then((response) => {
        setTickets(response.data.tickets);
        setTicketsPedding(response.data.ticketsPedding);
        setTicketsAttendant(response.data.ticketsAttendant);
        setTicketsTotal(response.data.ticketsTotal);
      })
      .catch(({ response }) => {
        setTickets([]);
        if (response?.data?.message) {
          toast.warn(response.data.message);
        } else {
          toast.warn(
            "Ocorreu um erro, verifique sua conexão e tente novamente"
          );
        }
      });
    setIsLoading(false);
  }
  const sendMessage = () => {
    if (!newMessage) {
      toast.warn("Escreva algo para enviar");
    } else {
      const messageSend = {
        send_type: user.type,
        ticket_id: selectedTicket.id,
        content: newMessage,
      };
      socket.emit("sendMessage", messageSend, (response) => {
        if (response.status === "ok") {
          setMessages((prevMessages) => [
            {
              content: newMessage,
              created_at: new Date(),
              send_id: user.id,
            },
            ...prevMessages,
          ]);
          const element = chatContainerRef.current;
          if (element) {
            element.scrollTop = element.scrollHeight;
          }
          setNewMessage("");
        } else {
          console.error(
            "Erro ao enviar mensagem, servidor rejeitou:",
            response.message
          );
          toast.warn("Falha ao enviar mensagem. Tente novamente.");
        }
      });
    }
  };

  async function acceptTicket() {
    setIsButtonLoading(true);
    const acceptChat = {
      ticket_id: selectedTicket.id,
    };
    socket.emit("acceptChat", acceptChat, (response) => {
      let editTicket = { ...selectedTicket };
      editTicket.status = "andamento";
      if (response.status === "ok") {
        setSelectedTicket(editTicket);
        setTicketsAttendant((prevTickets) => [editTicket, ...prevTickets]);
        setTicketsPedding((prevTickets) =>
          prevTickets.filter((item) => item.id != selectedTicket.id)
        );
      } else {
        toast.warn("Falha ao abrir chamado. Tente novamente.");
      }

      setIsButtonLoading(false);
    });
  }

  async function closedTicket() {
    setIsButtonLoading(true);
    const closedChat = {
      ticket_id: selectedTicket.id,
    };
    socket.emit("closedChat", closedChat, (response) => {
      let editTicket = { ...selectedTicket };
      editTicket.status = "finalizado";
      if (response.status === "ok") {
        setSelectedTicket(editTicket);
        setTickets((prevTickets) => [editTicket, ...prevTickets]);
        setTicketsAttendant((prevTickets) =>
          prevTickets.filter((item) => item.id != selectedTicket.id)
        );
        setTicketsTotal(ticketsTotal + 1);
      } else {
        toast.warn("Falha ao abrir chamado. Tente novamente.");
      }

      setIsButtonLoading(false);
    });
  }

  async function createTicket(selectedTicket) {
    setIsLoadingModal(true);
    if ((!newMessage || !sendUser) && !selectedTicket.order_id) {
      toast.warn(
        "Selecione para quem deseja abrir o chamado e deixe uma mensagem"
      );
      setIsLoadingModal(false);
    } else {
      const chatSend = {
        send_type: sendType,
        send_id: sendUser,
        content: selectedTicket.order_id
          ? `Chamado aberto relacionado a OS: ${selectedTicket.order_id}`
          : newMessage,
        ticket_id: selectedTicket.id,
      };
      socket.emit("createChat", chatSend, (response) => {
        if (response.status === "ok") {
          setNewMessage("");
          if (selectedTicket.id) {
            setSelectedTicket(response.data);
          }
          setTicketsAttendant((prevTickets) => [response.data, ...prevTickets]);
          setIsModalVisible(false);
          toast.success("Chamado aberto com sucesso, aguarde um atendente");
        } else {
          console.log(response);
          toast.warn(
            response.message || "Falha ao abrir chamado. Tente novamente."
          );
        }

        setIsLoadingModal(false);
      });
    }
  }
  if (selectedTicket) {
    return (
      <>
        <Content
          style={{
            maxWidth: 700,
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Button
              shape="round"
              onClick={() => {
                setSelectedTicket(null);
              }}
              style={{ marginBottom: 15 }}
            >
              Voltar
              {!!countMessages && (
                <div
                  style={{
                    borderRadius: 50,
                    width: 24,
                    height: 24,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    background: "#FF5D5D",
                    color: "#FFF",
                    position: "absolute",
                    fontSize: 13,
                    top: -10,
                    right: -10,
                  }}
                >
                  {countMessages}
                </div>
              )}
            </Button>
            <div className="ticket-actions">
              {selectedTicket.status === "pendente" && (
                <Button
                  type="primary"
                  shape="round"
                  loading={isButtonLoading}
                  onClick={() => {
                    acceptTicket();
                  }}
                >
                  Iniciar Atendimento
                </Button>
              )}
              {selectedTicket.status === "andamento" &&
                !!selectedTicket.order_id &&
                !selectedTicket.ticket_id && (
                  <Button
                    type="primary"
                    shape="round"
                    style={{ marginRight: 15 }}
                    loading={isButtonLoading}
                    onClick={() => {
                      confirm({
                        okText: "Confirmar",
                        title: `Deseja chamar o ${
                          selectedTicket.user_id ? "Técnico" : "Franqueado"
                        }?`,
                        icon: <ExclamationCircleFilled />,
                        content: `Um novo chamado vinculado a esse será aberto para o ${
                          selectedTicket.user_id ? "técnico" : "franqueado"
                        } após confirmação`,
                        onOk() {
                          createTicket(selectedTicket);
                        },
                        onCancel() {},
                        cancelText: "Cancelar",
                      });
                    }}
                  >
                    Chamar {selectedTicket.user_id ? "Técnico" : "Franqueado"}
                  </Button>
                )}
              {selectedTicket.status === "andamento" && (
                <Button
                  type="primary"
                  shape="round"
                  className="delete-button"
                  loading={isButtonLoading}
                  onClick={() => {
                    confirm({
                      okText: "Confirmar",
                      title: `Deseja finalizar o chamado?`,
                      icon: <ExclamationCircleFilled />,
                      content: `O chamado será finalizado após confirmação`,
                      onOk() {
                        closedTicket();
                      },
                      onCancel() {},
                      cancelText: "Cancelar",
                    });
                  }}
                >
                  Fechar Atendimento
                </Button>
              )}
            </div>
          </div>
          <TicketView>
            <TicketViewHeader>
              <div style={{ width: "50%" }}>
                <Avatar
                  src={
                    selectedTicket.user?.photo_url ||
                    selectedTicket.collaborator?.photo_url ||
                    null
                  }
                  icon={<MdPerson />}
                />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    margin: "0 15px",
                    flex: 1,
                  }}
                >
                  <h2>
                    {selectedTicket.user?.name ||
                      selectedTicket.collaborator?.name}
                  </h2>
                  <p>{selectedTicket.protocol_id}</p>
                </div>
              </div>
              {!!selectedTicket.order_id && (
                <div
                  style={{
                    marginBottom: 15,
                  }}
                >
                  <p
                    style={{
                      margin: "0 10px",
                    }}
                  >
                    OS relacionada:
                  </p>
                  <Button
                    type="primary"
                    style={{
                      borderRadius: 50,
                      height: 25,
                    }}
                    onClick={() => {
                      navigate(`/${user.type}/os/${selectedTicket.order_id}`);
                    }}
                  >
                    {selectedTicket.order_id}
                  </Button>
                </div>
              )}
              <Status
                style={{ marginBottom: 15, marginLeft: 16 }}
                isAttendant={true}
                status={selectedTicket.status}
              />
            </TicketViewHeader>

            <div
              className="chat-window-body"
              style={{
                display: "flex",
                padding: 16,
                height: "60vh",
                flexDirection: "column-reverse",
              }}
            >
              {messages.map((msg, index) => {
                const prevMsg = messages[index + 1] || null;
                const backMsg = index > 0 ? messages[index - 1] : null;

                // 1. Criamos chaves únicas para o minuto (Ex: "2025-12-17 16:30")
                // Isso ignora os segundos na comparação.
                const currentMinuteKey = format(
                  new Date(msg.created_at),
                  "yyyyMMddHHmm"
                );
                const prevMinuteKey = prevMsg
                  ? format(new Date(prevMsg.created_at), "yyyyMMddHHmm")
                  : null;
                const backMinuteKey = backMsg
                  ? format(new Date(backMsg.created_at), "yyyyMMddHHmm")
                  : null;

                // 2. Condição de Agrupamento: Mesmo Remetente E Mesmo Minuto
                const isGrouped =
                  prevMsg &&
                  String(prevMsg.send_id) === String(msg.send_id) &&
                  prevMinuteKey === currentMinuteKey;

                const isGroupedBack =
                  backMsg &&
                  String(backMsg.send_id) === String(msg.send_id) &&
                  backMinuteKey === currentMinuteKey;

                const messageClasses = [
                  "message",
                  msg.send_id === user.id ? "sent" : "received",
                  isGrouped || isGroupedBack ? "grouped" : "first-in-group",
                ].join(" ");

                return (
                  <div key={msg.id || index} className={messageClasses}>
                    <div
                      className={`message-content ${
                        isGrouped || isGroupedBack ? "no-tip" : ""
                      }`}
                    >
                      <p>{msg.content}</p>
                    </div>
                    {!isGroupedBack && (
                      <div
                        className="message-header"
                        style={{
                          display: "flex",
                          justifyContent:
                            msg.send_id === user.id ? "flex-end" : "flex-start",
                          gap: "8px",
                        }}
                      >
                        <span
                          className="time-label"
                          style={{
                            fontSize: "0.7rem",
                            margin: "5px 0",
                            color: "#888",
                          }}
                        >
                          {format(
                            new Date(msg.created_at),
                            isToday(new Date(msg.created_at))
                              ? "HH:mm"
                              : "dd/MM/yyyy HH:mm"
                          )}
                        </span>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
            {selectedTicket.status === "andamento" && (
              <div className="chat-footer">
                <Input
                  placeholder="Digite sua mensagem..."
                  value={newMessage}
                  onChange={(e) => setNewMessage(e.target.value)}
                  onPressEnter={() => {
                    sendMessage();
                  }}
                  suffix={
                    <Button
                      type="primary"
                      icon={<SendOutlined />}
                      onClick={() => {
                        sendMessage();
                      }}
                    />
                  }
                />
              </div>
            )}
          </TicketView>
        </Content>
      </>
    );
  }

  function renderTicket(ticket, message, messageView) {
    const messagesNotView = ticket.messages.filter((item) => {
      return item.send_id != user.id && !item.is_viewed;
    }).length;
    return (
      <TicketCard
        key={ticket.id}
        onClick={() => {
          setSelectedTicket(ticket);
          setNewMessage("");
          setMessages(ticket.messages);
          const element = chatContainerRef.current;
          if (element) {
            element.scrollTop = element.scrollHeight;
          }
        }}
      >
        <Card>
          <div className="card-header">
            <span
              style={{
                flex: 1,
              }}
            >
              {ticket.protocol_id}
            </span>
            <div
              style={{
                display: "flex",
              }}
            >
              {!!ticket.order_id && (
                <Button
                  type="primary"
                  style={{
                    borderRadius: 50,
                    height: 20,
                    margin: "0 15px",
                  }}
                  onClick={() => {
                    navigate(`/${user.type}/os/${ticket.order_id}`);
                  }}
                >
                  {ticket.order_id}
                </Button>
              )}
              <Status isAttendant={true} isMini={true} status={ticket.status} />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Card.Meta
              avatar={
                <Avatar
                  src={
                    ticket.user?.photo_url ||
                    ticket.collaborator?.photo_url ||
                    null
                  }
                  icon={<MdPerson />}
                />
              }
              style={{ flex: 1 }}
              title={ticket.user?.name || ticket.collaborator?.name}
              description={messageView}
            />
            {!!messagesNotView && (
              <div
                style={{
                  borderRadius: 50,
                  width: 26,
                  height: 26,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  background: "#FF5D5D",
                  color: "#FFF",
                }}
              >
                {messagesNotView}
              </div>
            )}
          </div>
          {ticket.status == "pendente" && (
            <div className="ticket-info">
              <span>
                Aberto em{" "}
                {format(new Date(ticket.created_at), "dd/MM/yyyy HH:mm")}{" "}
              </span>
            </div>
          )}
          {ticket.status == "finalizado" && (
            <div className="ticket-info">
              <span>
                Finalizado em{" "}
                {format(new Date(ticket.updated_at), "dd/MM/yyyy HH:mm")}{" "}
              </span>
            </div>
          )}
          {ticket.status == "andamento" && (
            <div className="ticket-info" style={{}}>
              <span>
                {format(new Date(message.created_at), "dd/MM/yyyy HH:mm")}{" "}
              </span>
            </div>
          )}
        </Card>
      </TicketCard>
    );
  }

  return (
    <>
      <Content>
        <ButtonGroup>
          <Button
            shape="round"
            type={filter === "attendant" ? "primary" : "default"}
            onClick={() => {
              setFilter("attendant");
            }}
          >
            Chamados em Aberto ({ticketsAttendant.length})
            {!!countMessages && (
              <div
                style={{
                  borderRadius: 50,
                  width: 24,
                  height: 24,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  background: "#FF5D5D",
                  color: "#FFF",
                  position: "absolute",
                  fontSize: 13,
                  top: -10,
                  right: -10,
                }}
              >
                {countMessages}
              </div>
            )}
          </Button>
          <Button
            shape="round"
            type={filter === "pedding" ? "primary" : "default"}
            onClick={() => {
              setFilter("pedding");
            }}
          >
            Chamados Pendentes ({ticketsPedding.length})
          </Button>
          <Button
            shape="round"
            type={filter === "finish" ? "primary" : "default"}
            onClick={() => {
              setFilter("finish");
            }}
          >
            Chamados Finalizados ({ticketsTotal})
          </Button>
          <Button
            shape="round"
            type={"primary"}
            onClick={() => {
              setSendUser("");
              setSendType("");
              setNewMessage("");
              setIsModalVisible(true);
            }}
          >
            Abrir Chamado
          </Button>
        </ButtonGroup>
        {filter == "finish" && (
          <>
            {!ticketsTotal && (
              <Message
                style={{
                  width: "70%",
                  alignSelf: "center",
                  marginTop: 60,
                }}
              >
                Nenhum chamado foi encontrado
              </Message>
            )}
            <TicketList>
              {tickets.map((ticket) => {
                const message = ticket.messages[0];
                const messageView =
                  message.send_id == user.id
                    ? `Você: ${message.content}`
                    : message.content;
                return renderTicket(ticket, message, messageView);
              })}
            </TicketList>
          </>
        )}
        {filter == "pedding" && (
          <>
            {!ticketsPedding.length && (
              <Message
                style={{
                  width: "70%",
                  alignSelf: "center",
                  marginTop: 60,
                }}
              >
                Nenhum chamado foi encontrado
              </Message>
            )}
            <TicketList>
              {ticketsPedding.map((ticket) => {
                const message = ticket.messages[0];
                const messageView =
                  message.send_id == user.id
                    ? `Você: ${message.content}`
                    : message.content;
                return renderTicket(ticket, message, messageView);
              })}
            </TicketList>
          </>
        )}
        {filter == "attendant" && (
          <>
            {!ticketsAttendant.length && (
              <Message
                style={{
                  width: "70%",
                  alignSelf: "center",
                  marginTop: 60,
                }}
              >
                Nenhum chamado foi encontrado
              </Message>
            )}
            <TicketList>
              {ticketsAttendant.map((ticket) => {
                const message = ticket.messages[0];
                const messageView =
                  message.send_id == user.id
                    ? `Você: ${message.content}`
                    : message.content;
                return renderTicket(ticket, message, messageView);
              })}
            </TicketList>
          </>
        )}
      </Content>

      <Modal
        title="Abertura de Chamado"
        open={isModalVisible}
        isLoading={isLoadingModal}
        onOk={() => {
          createTicket("");
        }}
        onCancel={() => {
          setIsModalVisible(false);
        }}
        okText="Abrir Chamado"
        cancelText="Cancelar"
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}
        >
          <p style={{ width: "100%", margin: "10px 0 5px 5px", fontSize: 12 }}>
            Abrir chamado para?
          </p>
          <Button
            type={sendType == "cliente" && "primary"}
            style={{ width: "48%" }}
            onClick={() => {
              setSendType("cliente");
              setSendUser(null);
            }}
          >
            Franqueado
          </Button>
          <Button
            type={sendType == "tecnico" && "primary"}
            style={{ width: "48%" }}
            onClick={() => {
              setSendType("tecnico");
              setSendUser(null);
            }}
          >
            Técnico
          </Button>
        </div>
        {sendType && (
          <ViewInput style={{ width: "100%", marginRight: 15, marginTop: 5 }}>
            <p>Selecionar {sendType == "cliente" ? "Franqueado" : "Técnico"}</p>
            <Select
              placeholder={`selecionar ${
                sendType == "cliente" ? "franqueado" : "técnico"
              }`}
              value={sendUser || null}
              showSearch
              optionFilterProp="children"
              style={{ width: "100%", textAlign: "left" }}
              onChange={(value) => {
                setSendUser(value);
              }}
            >
              {users.map((item) => {
                if (sendType == "cliente") {
                  return (
                    <Select.Option value={item.id}>{item.name}</Select.Option>
                  );
                }
              })}
              {collaborators.map((item) => {
                if (sendType == "tecnico") {
                  return (
                    <Select.Option value={item.id}>{item.name}</Select.Option>
                  );
                }
              })}
            </Select>
          </ViewInput>
        )}
        <ViewInput style={{ margin: "5px 0" }}>
          <p>Escreva sua dúvida</p>
          <Input.TextArea
            value={newMessage}
            onChange={(text) => {
              setNewMessage(text.target.value);
            }}
            style={{ minHeight: 80 }}
          />
        </ViewInput>
        <p>Horário de Atendimento</p>
        <p>Segunda a Sexta</p>
        <p> 8hrs as 12hrs / 14hrs as 18hrs</p>
      </Modal>
    </>
  );
};

export default Atendimentos;
